import { useEffect, useState, useContext } from "react"
import { Box, Card, Chip, Grid, IconButton, Tab, Tabs, Typography } from "@mui/material"
import { useTheme } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { ButtonBasic, TableBase } from "../../components"
import { showModal } from "react-redux-modal-provider";
import { SocketContext } from "../../context/SocketContext";
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import ConfirmationDialog from "../../modals/default/ConfirmationDialog";
import UserService from "../../services/personas.service";
import ModalAddAsesores from "../../modals/asesores/ModalAddAsesores";

function TabPanel({ children, value, index }) {
    return (
        <div role="tabpanel" hidden={value !== index} id={`asesores-tabpanel-${index}`}>
            {value === index && children}
        </div>
    );
}

const UsuariosAsesoresScreen = () => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [tab, setTab] = useState(0);
    const [itemsAsesores, setItemsAsesores] = useState([]);
    const [itemsEnlaces, setItemsEnlaces] = useState([]);
    const { sockets } = useContext( SocketContext );

    const actualizarAsesores = async() =>{
        await UserService.getAll({type : 'asesores'}).then((response) =>{
            setItemsAsesores(response)
        })
    }
    const actualizarEnlaces = async() =>{
        await UserService.getAll({type : 'enlaces'}).then((response) =>{
            setItemsEnlaces(response)
        })
    }

    const getColumns = (items, tipo) => [
        {
            name: "id_p",
            label: "ID",
            options: {
                filter: false,
                sort: false,
                display:false,
                viewColumns: false
            }
        },
        {
            name: "nombre_p",
            label: "Nombre Completo",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "dni_p",
            label: "DNI",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "email_p",
            label: "Correo Electronico",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "telPersonal_p",
            label: "Telefono",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: 'activo_p',
            label: "Estado",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    if(value) return <Chip label="Activo" color="success" />
                    return <Chip label="Inactivo" color="error" />
                }
            }
        },
        {
            name: 'actions',
            label: "Acciones",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <>
                        <Box display='flex'>
                            <IconButton color='info' aria-label="edit" onClick={()=>onOpenEditar(items, tipo, tableMeta.rowData[0])}>
                                <EditIcon fontSize="medium" sx={{color: isDarkMode ? '#90caf9' : '#0364ff'}} />
                            </IconButton>
                            <IconButton color='info' aria-label="edit" onClick={()=>onEliminar(items, tipo, tableMeta.rowData[0])}>
                                { tableMeta.rowData[5] ?(
                                    <DeleteIcon fontSize="medium" sx={{color: isDarkMode ? '#f87171' : '#e01010'}} />
                                ):(
                                    <PublishedWithChangesIcon fontSize="medium" sx={{color: isDarkMode ? '#4ade80' : '#018155'}} />
                                )}
                            </IconButton>
                        </Box>
                    </>
                )
            }
        }
    ];
    const onGuardar = (tipo) => {
        if(tipo === 'enlace') actualizarEnlaces();
        else actualizarAsesores();
    };
    const onOpenEditar = (items, tipo, item) => {
        if(item){
            const searchItem = items.find((sItem)=> sItem.id_p === item)
            showModal(ModalAddAsesores, {item: searchItem, type: tipo, onGuardar: ()=>onGuardar(tipo)});
        }else{
            showModal(ModalAddAsesores, {type: tipo, onGuardar: ()=>onGuardar(tipo)});
        }
    };
    const onEliminar = (items, tipo, item) => {
        const searchItem = items.find((sItem)=> sItem.id_p === item)
        const etiqueta = tipo === 'enlace' ? 'Enlace' : 'Asesor';
        showModal(ConfirmationDialog, {
            title: `${!searchItem?.activo_p ? 'Activar' : 'Desactivar'} ${etiqueta}`,
            message: `¿Esta seguro que desea ${!searchItem?.activo_p ? 'activar' : 'desactivar'} el ${etiqueta}?`,
            onConfirm: () => {
                const deleteFn = tipo === 'enlace' ? UserService.deleteEnlace : UserService.deleteAsesor;
                deleteFn(searchItem.id_p).then(() => {
                    onGuardar(tipo);
                });
            }
        });
    };
    useEffect(() => {
        actualizarAsesores();
        actualizarEnlaces();
        document.title = 'Asesores-Personal';
    }, [])


    return (
        <Box sx={{width:'100%',height: '100%',overflow:'auto', bgcolor: isDarkMode ? '#1a2332' : '#f5f5f5'}} className='side'>
            <Grid container p={3} display='flex' justifyContent='center'>
                <Grid item xs={6}>
                    <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold'}} variant="h2">Asesores</Typography>
                </Grid>
                <Grid item xs={6} sx={{display: 'flex', justifyContent: 'end'}}>
                    <ButtonBasic
                        textButton={tab === 0 ? "Nuevo Asesor" : "Nuevo Enlace"}
                        sx={{width: 200, height: 30}}
                        onClick={()=>onOpenEditar(tab === 0 ? itemsAsesores : itemsEnlaces, tab === 0 ? 'asesor' : 'enlace')}
                        variant='wk'
                        color="nextStep"
                    />
                </Grid>
                <Grid item xs={12} mt={2}>
                    <Card sx={{background: isDarkMode ? '#2d3a52 !important' : '#fff !important'}}>
                        <Box sx={{ borderBottom: 1, borderColor: isDarkMode ? '#3d4a62' : 'divider' }}>
                            <Tabs
                                value={tab}
                                onChange={(e, newValue)=>setTab(newValue)}
                                sx={{
                                    '& .MuiTabs-indicator':{ background: isDarkMode ? '#64B5F6' : '#0364ff' },
                                    '& .MuiButtonBase-root':{ color: isDarkMode ? '#a0a0a0' : '#6b788e', fontWeight: 'bold' },
                                    '& .MuiButtonBase-root.Mui-selected':{ color: isDarkMode ? '#64B5F6' : '#0364ff' }
                                }}
                            >
                                <Tab label="Asesores - Usuarios" />
                                <Tab label="Asesores - Enlaces" />
                            </Tabs>
                        </Box>
                        <TabPanel value={tab} index={0}>
                            <Box p={2}>
                                <TableBase title='Resultados' columns={getColumns(itemsAsesores, 'asesor')} data={itemsAsesores} />
                            </Box>
                        </TabPanel>
                        <TabPanel value={tab} index={1}>
                            <Box p={2}>
                                <TableBase title='Resultados' columns={getColumns(itemsEnlaces, 'enlace')} data={itemsEnlaces} />
                            </Box>
                        </TabPanel>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    )
}

export default UsuariosAsesoresScreen